(function () {
    'use strict';
    angular.module('doclr.customMessage', []);
})();